import './textarea.scss'
import InputWrapper from "../input-wrapper/input-wrapper"

const Textarea = (props) => {
    const {
        error,
        displayError,
        message,
        helpertext,
        label,
        tooltip,
        ...inputProps} = props

    return (
        <InputWrapper {...props} inputType="text" >
        <span className="group">
            <textarea 
                id={props.id || props.name}
                rows="3"
                {...inputProps}>
            </textarea>
        </span>
        <span style={{display:"flex", width:"100%", justifyContent:"flex-end"}}>{`${props.maxLength ? `${props.value ? props.value.length : '0'}/${props.maxLength}`:''}`}</span>
        </InputWrapper>
    )
}

export default Textarea;